import { types as adminTypes } from '../admin/ducks';
import { types as publicTypes } from '../public/ducks';

const types = { ...adminTypes, ...publicTypes };

export {
  types
};
